import React from "react";
import Nav from "../../Components/RedSeaContracting/Nav";
import HomeIntro from "../../Components/RedSeaContracting/HomeIntro";
import About from "../../Components/RedSeaContracting/About";
import Services from "../../Components/RedSeaContracting/Services";
import Construction from "../../Components/RedSeaContracting/Construction";
import Machinery from "../../Components/RedSeaContracting/Machinery";
import GlobalFooter from "../../Components/assets/GlobalFooter";
import intlnavlogolight from "../../Images/Logos/intl-contracting-light.png";
import colors from "../../util/colors";
import GlobalPage from "../GlobalPage";
import { contacts } from "../../util/data";
import { useSelector } from "react-redux";
import ContactUs from "../../Components/assets/ContactUs";

const RsContrHome = () => {
  const language = useSelector((state) => state.language);
  return (
    <GlobalPage>
      <Nav language={language} />
      <HomeIntro language={language} />
      <About language={language} />
      <Services language={language} />
      <Construction language={language} />
      <Machinery language={language} />
      <ContactUs
        language={language}
        headerColor={colors.burgundy}
        strokeColor={colors.beige}
        buttonColor={colors.burgundy}
      />
      {/* <Footer /> */}
      <GlobalFooter
        logo={intlnavlogolight}
        bgColor={colors.burgundy}
        contacts={contacts[language].contracting}
      />
    </GlobalPage>
  );
};

export default RsContrHome;
